import React from 'react';
import './FollowNavigator.scss';

const FollowNavigator = () => {
  return (
    <a
      href="https://smartstore.naver.com/namsanworks"
      className="smartStoreATag"
      target="_blank"
      rel="noreferrer"
    >
      <div className="followNavigator">
        스토어
        <br /> 바로가기
      </div>
    </a>
  );
};

export default FollowNavigator;
